import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import Phone from './phone'
import History from './calls'
import Clients from './clients'
import Tickets from './tickets'
import ToDescribe from './toDescribe'
import IncomingNotify from './phone/IncomingNotify'
import Campaigns from './campaigns'
import Settings from './settings'
import { ToastContainer } from 'react-toastify'
import Chat from './chat'
import classNames from 'classnames'
import InternalChat from './internalChat'

const Main: React.FC = ({}) => {
  return (
    <div
      className={classNames('main', {
        // 'main--without-phone': !window.c.menuVisible,
      })}
    >
      <Switch>
        <Route path="/settings">
          <Settings />
        </Route>
        <Route path="/phone">
          <Phone />
        </Route>
        <Route path="/chat">
          <Chat />
        </Route>
        <Route path="/internal-chat">
          <InternalChat />
        </Route>
        <Route path="/calls">
          <History />
        </Route>
        <Route path="/to-describe">
          <ToDescribe />
        </Route>
        <Route path="/clients">
          <Clients />
        </Route>
        <Route path="/tickets">
          <Tickets />
        </Route>
        <Route path="/campaigns">
          <Campaigns />
        </Route>
        <Route path="/calendar"></Route>
        <Redirect from="/" to={!window.c.phoneEnabled ? '/chat' : '/phone'} />
      </Switch>
      <IncomingNotify />
      <ToastContainer />
    </div>
  )
}

export default Main
